export default __webpack_public_path__ + "static/media/Dragon Gas.b76d5700.PNG";